export default "__VITE_ASSET__37lgnuGf__"